import { render, staticRenderFns } from "./addExamPaper.vue?vue&type=template&id=b1605d82&scoped=true&"
import script from "./AddPaper.js?vue&type=script&lang=js&"
export * from "./AddPaper.js?vue&type=script&lang=js&"
import style0 from "./addExamPaper.vue?vue&type=style&index=0&id=b1605d82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1605d82",
  null
  
)

export default component.exports